import { render, staticRenderFns } from "./InsuranceSettings.vue?vue&type=template&id=322d25e9&scoped=true&"
import script from "./InsuranceSettings.vue?vue&type=script&lang=js&"
export * from "./InsuranceSettings.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceSettings.vue?vue&type=style&index=0&id=322d25e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322d25e9",
  null
  
)

export default component.exports